import Index from '@/components/setting/Index.vue'
import Account from '@/components/setting/Account.vue'

export default {
  path: 'setting',
  component: Index,
  redirect: to => {
    return `${to.path}/account`
  },
  children: [{
    path: 'account',
    component: Account
  }, ]
}



// WEBPACK FOOTER //
// ./src/router/setting.js